var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{attrs:{"value":_vm.value,"value-key":_vm.type=='object'?'id':'',"size":_vm.size,"placeholder":_vm.placeholder},on:{"visible-change":_vm.visiblechange,"change":_vm.change}},_vm._l((_vm.list),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.customFrom,"value":_vm.type=='object'?item:item.id}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }